import React from 'react';
import {MDBDataTable} from "mdbreact";
import {Empty} from "antd";
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import * as tbl_headers from '../user_group_table_headers_util';
import {Button as SementicBtn, Button, Radio} from "semantic-ui-react";
import UpdateUserGroupModal from "../UpdateUserGroupModal";
import AddUsersModal from '../AddUsersModal/index';
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as innerRoutes from "../user_group_route_util";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_tag";
import apiConfig from "../../../axios/axios_api_services";
import * as common from "../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";

class UserGroupUsersComponent extends React.Component {

  state = {
    userGroupId: 0,
    corporateId: 0,
    userGroupName: "",
    updateModal: false,

    users:[],
  };

  componentDidMount() {
    let userGroup = this.props.user_group;
    if(userGroup ===  null) {
      this.props.history.push(innerRoutes.inner_route_tags_user_groups);
    } else {
      this.setState({
        userGroupId: userGroup.userGroupId,
        corporateId: userGroup.corporateId,
        userGroupName: userGroup.groupName,
      });
      this.callUserData(userGroup.userGroupId, 1000, 0);
    }
  }

  callUserData = (userGroupId, size, page) => {
    this.callUserData_(userGroupId, size, page);
  };

  callUserData_ = (userGroupId, size, page) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
      axios.get(apiConfig.CORPORATE_USER_GROUP_USERS(userGroupId, size, page),{headers:headers}).then(r =>{
        if(r.status === 200) {
          this.setState({
            users: r.data.content
          });
        }
      }).catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.callUserData_(userGroupId, size, page);
        }
      }).finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  removeUserFromGroup = (r) => {

    let fullName = r.firstName + " " + r.lastName;

    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to remove " + fullName +"?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.removeUserFromGroup_(r);
          break;
        default:
          break;
      }
    });
  };

  removeUserFromGroup_ = (r) => {
    let userGroupId = this.props.user_group.userGroupId;
    let userId = r.userId;
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axios.delete(apiConfig.DELETE_GROUP_USER(userGroupId, userId),{headers:headers}).then(r =>{
      if(r.status === 200) {
        common.warningAlert("User had removed successfully!", 0);
        this.callUserData(userGroupId, 1000, 0);
      }
    }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.removeUserFromGroup_(r);
      }
    }).finally(fin => {
      this.props.spinnerHandler(false);
    });
  };

  openAddUserModal = () => {
    this.setState({
      updateModal: true
    });
  };

  closeModal = () => {
    this.setState({updateModal: false});
    this.callUserData(this.state.userGroupId, 1000, 0);
  };

  render() {

    let {updateModal, userGroupName, users} = this.state;

    let row = [];

    if(users.length>0) {
      users.map((r, i)=>{
        let obj = {
            user_id: r.userId,
            employee_id: r.empId,
            first_name: r.firstName,
            last_name: r.lastName,
            nic: r.identificationValue,
            mobile: r.mobile,
            email: r.email,
            active: r.status,
            remove: <div>
              <SementicBtn
                className="cus-btn"
                circular icon='trash alternate'
                onClick={() => this.removeUserFromGroup(r)}
              />
            </div>,
        };
        row.push(obj);
      });
    }

    let draftData = {columns: tbl_headers.USERS_TBL_HEADERS, rows: row};
    return(
      <div>
        {
          updateModal?
          <AddUsersModal isOpen={true} userGroupDetails={this.props.user_group} closeModal={this.closeModal} />:null
        }
        <Row>
          <Col lg={"12"} style={{marginBottom: '5px', marginTop: '10px', textAlign: "end"}}>
            <Button
              className="px-5"
              onClick={this.openAddUserModal}
            ><i aria-hidden="true" className="plus icon"></i>
              New Users
            </Button>
          </Col>
          <Col>
            <Card>
              <CardHeader>
                Users of User Group: {userGroupName}
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <MDBDataTable
                    searching={true}
                    displayEntries={true}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    bordered
                    hover
                    data={draftData}
                  />
                  {/*:*/}
                  {/*<div className={"align-center fully-width"}>*/}
                  {/*  <Empty description={"Records not found"} className={"empty-icon"}/>*/}
                  {/*</div>*/}
                </CardBody>
              </Collapse>
            </Card>
          </Col>

        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user_group: state.userGroupReducer.userGroupDetails,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setUserGroupHandler: (data) => dispatch(actionCreator.saveUserGroupDetails(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserGroupUsersComponent));
